import React from "react";
import { Nav, Tab } from "react-bootstrap";
import CalenderViewLectures from "../Section/CalenderViewLectures";
import SubjectByLectures from "../Section/SubjectByLectures";
import NotWatched from "../Section/NotWatch";
import ExceptionalLectures from "../Section/ExceptionalLectures";
import ListLectures from "../Section/ListLectures";
import LectureByNotes from "../Section/LectureByNotes";
import { useCourse } from "context/context";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import PersonalizedListLectures from "./PesonalizedLectureList";
import "./PesonalizedLectureInnerLayout.scss";

const LectureInnerLayout = () => {
    const { course, mentorfindstudentformflag } = useCourse();
    const [type, setType] = React.useState("list");
    const [activeKey, setActiveKey] = React.useState("");
    const navigate = useNavigate();

    return (
        <>
            <div className="personalized_lecture_content">
                <div className="container">
                    <Tab.Container id="left-tabs-example" defaultActiveKey="List_view">
                        <div>
                            <PersonalizedListLectures />
                        </div>
                    </Tab.Container>
                </div>
            </div>
        </>
    );
};

export default LectureInnerLayout;
